import { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext([]);

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const loggedInUserData = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    if (loggedInUserData) {
      setUserData(loggedInUserData);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ userData, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useAuthData = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
